import { render, staticRenderFns } from "./SimplePicker.vue?vue&type=template&id=2f08740a"
import script from "./SimplePicker.vue?vue&type=script&lang=js"
export * from "./SimplePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports